import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import store from '../store';
import { fetchAnswerApi } from './conversationApi';
import { getConversations } from './preferences/preferenceApi';
import { setConversations } from './preferences/preferenceSlice';

const initialState = {
    queries_mindmap: [],
    status: 'idle',
    conversationId: null
};

// const API_STREAMING = import.meta.env.VITE_API_STREAMING === 'true';
const API_STREAMING = false;

export const fetchAnswerMindmap = createAsyncThunk('fetchAnswerMindmap', async ({ question }, { dispatch, getState }) => {
    const state = getState();
    if (state.preference) {
        // if (API_STREAMING) {
        //   await fetchAnswerSteaming(
        //     question,
        //     state.preference.apiKey,
        //     state.preference.selectedDocs,
        //     state.conversation.queries_mindmap,
        //     state.conversation.conversationId,
        //     (event) => {
        //       const data = JSON.parse(event.data);

        //       // check if the 'end' event has been received
        //       if (data.type === 'end') {
        //         // set status to 'idle'
        //         dispatch(conversationSlice.actions.setStatus('idle'));
        //         getConversations()
        //           .then((fetchedConversations) => {
        //             dispatch(setConversations(fetchedConversations));
        //           })
        //           .catch((error) => {
        //             console.error('Failed to fetch conversations: ', error);
        //           });
        //       } else if (data.type === 'source') {
        //         // check if data.metadata exists
        //         let result;
        //         if (data.metadata && data.metadata.title) {
        //           const titleParts = data.metadata.title.split('/');
        //           result = {
        //             title: titleParts[titleParts.length - 1],
        //             text: data.doc,
        //           };
        //         } else {
        //           result = { title: data.doc, text: data.doc };
        //         }
        //         dispatch(
        //           updateStreamingSource({
        //             index: state.conversation.queries_mindmap.length - 1,
        //             query: { sources: [result] },
        //           }),
        //         );
        //       } else if (data.type === 'id') {
        //         dispatch(
        //           updateConversationId({
        //             query: { conversationId: data.id },
        //           }),
        //         );
        //       } else {
        //         const result = data.answer;
        //         dispatch(
        //           updateStreamingQuery({
        //             index: state.conversation.queries_mindmap.length - 1,
        //             query: { response: result },
        //           }),
        //         );
        //       }
        //     },
        //   );
        // } else {
        const answer = await fetchAnswerApi(
            question,
            state.preference.apiKey,
            state.preferenceMindmap.selectedDocs,
            state.conversationMindmap.queries_mindmap,
            state.conversationMindmap.conversationId
        );
        if (answer) {
            // console.log("--------------------------")
            // console.log(answer)
            let sourcesPrepped = [];

            if (answer.sources !== '') {
                sourcesPrepped = answer.sources.map((source) => {
                    if (source && source.title) {
                        const titleParts = source.title.split('/');
                        return {
                            ...source,
                            title: titleParts[titleParts.length - 1]
                        };
                    }
                    return source;
                });

                dispatch(
                    updateQuery({
                        index: state.conversationMindmap.queries_mindmap.length - 1,
                        query: { response: answer.answer, sources: sourcesPrepped }
                    })
                );
                dispatch(
                    updateConversationId({
                        query: { conversationId: answer.conversationId }
                    })
                );
                dispatch(conversationMindmapSlice.actions.setStatus('idle'));
                getConversations()
                    .then((fetchedConversations) => {
                        dispatch(setConversations(fetchedConversations));
                    })
                    .catch((error) => {
                        console.error('Failed to fetch conversations: ', error);
                    });
            } else {
                dispatch(
                    updateQuery({
                        index: state.conversationMindmap.queries_mindmap.length - 1,
                        query: { response: answer.answer, sources: [] }
                    })
                );
                dispatch(
                    updateConversationId({
                        query: { conversationId: answer.conversationId }
                    })
                );
                dispatch(conversationMindmapSlice.actions.setStatus('idle'));
                getConversations()
                    .then((fetchedConversations) => {
                        dispatch(setConversations(fetchedConversations));
                    })
                    .catch((error) => {
                        console.error('Failed to fetch conversations: ', error);
                    });
            }
        }
    }
    // }
    return {
        conversationId: null,
        title: null,
        answer: '',
        query: question,
        result: '',
        sources: []
    };
});

export const conversationMindmapSlice = createSlice({
    name: 'conversationMindmap',
    initialState,
    reducers: {
        addQuery(state, action) {
            state.queries_mindmap.push(action.payload);
        },
        setConversation(state, action) {
            state.queries_mindmap = action.payload;
        },
        updateStreamingQuery(state, action) {
            const { index, query } = action.payload;
            if (query.response) {
                state.queries_mindmap[index].response = (state.queries_mindmap[index].response || '') + query.response;
            } else {
                state.queries_mindmap[index] = {
                    ...state.queries_mindmap[index],
                    ...query
                };
            }
        },
        updateConversationId(state, action) {
            state.conversationId = action.payload.query.conversationId ?? null;
        },
        updateStreamingSource(state, action) {
            const { index, query } = action.payload;
            if (!state.queries_mindmap[index].sources) {
                state.queries_mindmap[index].sources = [query.sources[0]];
            } else {
                state.queries_mindmap[index].sources.push(query.sources[0]);
            }
        },
        updateQuery(state, action) {
            const { index, query } = action.payload;
            state.queries_mindmap[index] = {
                ...state.queries_mindmap[index],
                ...query
            };
        },
        setStatus(state, action) {
            state.status = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAnswerMindmap.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAnswerMindmap.rejected, (state, action) => {
                // console.log(state)
                state.status = 'failed';
                state.queries_mindmap[state.queries_mindmap.length - 1].error = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
            });
    }
});

export const selectQueries = (state) => state.conversationMindmap.queries_mindmap;

export const selectStatus = (state) => state.conversationMindmap.status;

export const { addQuery, updateQuery, updateStreamingQuery, updateConversationId, updateStreamingSource, setConversation } =
    conversationMindmapSlice.actions;
export default conversationMindmapSlice.reducer;
